import { useMutation } from "react-query";
import { useHandleGenerateResult } from "@/hooks/useHandleGenerateResult";
import { userGenerateDashboard } from "@/services/user";
import { useConfig, useError } from "@/states/common.state";
import { useIsloading } from "@/states/ui.state";
import { typesRequiredRegister } from "@/components/page-modules/home-page/GenerateTypes/PreviewResult/data/preview-result.repository";
import { useQrShowState } from "@/states/qr.state";
import { useSolutionsSelect } from "@/states/solution.state";

type mutationFnType = {
  params?: Record<string, any>;
  configParams?: Record<string, any>;
};
export default function useGenerateHomeQr(with_validation: boolean = true) {
  const { handleGenerateResult } = useHandleGenerateResult();
  const { setError } = useError.getState();
  const { setIsloading } = useIsloading.getState();
  const { setConfig, setPayload, config } = useConfig.getState();
  const { setDashboardQr, setQrShowId } = useQrShowState.getState();

  const mutation = useMutation({
    mutationFn: ({ params, configParams }: mutationFnType = {}) => {
      const { solutionsSelectedTypes } = useSolutionsSelect.getState();
      const combinedConfig = { ...config, ...configParams };

      return userGenerateDashboard.postQRStore(
        { ...params, config: combinedConfig },
        solutionsSelectedTypes!,
      );
    },
    onSuccess: (data) => {
      const resData = data?.data;
      if (resData) {
        setConfig(resData.config);
        setPayload(resData.payload);
        handleGenerateResult(data);

        if (typesRequiredRegister.includes(resData.type || "")) {
          resData.payload = {};
          resData.svgContent = {};
        }

        setDashboardQr(resData);
        resData?.id && setQrShowId(resData.id);
        resData?.redirectCondition && setIsloading(true);
      }
      if (with_validation) {
        setError(resData?.validation_errors || null);
      }
    },
    onSettled: () => {
      setTimeout(() => setIsloading(false), 800);
    },
    onError: ({ response }) => {
      setError(response?.data?.errors);
      setIsloading(false);
    },
  });

  return {
    mutateHomeQr: mutation.mutate,
    mutateLoading: mutation.isLoading,
    hasError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isIdle: mutation.isIdle,
  };
}
